export const FEATURE_SELECTOR_ITEMS = [
  ["AI", "humn-ai"],
  ["Feed", "discovery-feed"],
  ["Cards", "humn-cards"],
  ["Happenings", "my-happenings"],
  ["Connect", "connect"],
  ["Learn", "learn"],
  ["Join", "join"],
  ["Ask", "ask"],
  ["Explore", "explore"],
  ["Book", "book"],
  ["Subscribe", "subscribe"],
  ["Order", "order"],
  ["Moments", "moments"],
  ["Go Live", "go-live"],
  ["Muse", "muse"],
  ["Credits", "credits"],
];

export const INTENTIONS = [
  ["I want to learn guitar.", "Learn", "4 local teachers"],
  ["I want to find someone for a sunrise hike.", "Connect", "12 nearby hikers"],
  ["I want to learn authentic Japanese cooking.", "Learn", "3 hosts in Tokyo"],
  ["I need someone who knows Sanskrit.", "Ask", "8 verified experts"],
  ["I want to explore underground music in Berlin.", "Explore", "6 live Happenings"],
];

export const HAPPENINGS = [
  ["Guitar Class", "Today · 18:30", "4 participants", "120 Credits", "Live"],
  ["Berlin Street Art Walk", "Sat · 10:00", "9 participants", "Free", "Confirmed"],
  ["Sushi Workshop", "Sun · 11:00", "You + Kenji", "299 Credits", "Escrow held"],
  ["Weekend Trek", "Next Fri", "7 participants", "80 Credits", "Planning"],
];

export const GLOBAL_CONNECTIONS = [
  ["Germany", "Learn Sanskrit", 19, 25, 1],
  ["Brazil", "Music collaboration", 33, 69, 3],
  ["Berlin", "Street-art walk", 48, 27, 5],
  ["Jaipur", "Order pottery", 69, 54, 6],
  ["Tokyo", "Food discovery", 86, 38, 7],
];